<template>
  <div class="linkage-customerOperate-personal-list">
    <base-list-management
      ref="baseListManagement"
      :configData.sync="configData"
    >
      <div slot="custom-export">
        <el-button
          :loading="exportLoading"
          @click="exportData"
          v-if="judgePermission('personOperateExport')"
          >导出数据</el-button
        >
        <el-button
          @click="exportList"
          v-if="judgePermission('personOperateExportList')"
          >导出列表</el-button
        >
      </div>
    </base-list-management>
    <ExportListDialog
      @init="handleExportListDialogInit"
      :dialogVisible="listShow"
      :taskType="4"
      fileName="个人客户运营"
      @close="() => (this.listShow = false)"
    />
  </div>
</template>
<script>
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
// eslint-disable-next-line import/no-cycle
import {
  getPersonOperateListSensitive,
  exportPersonOperateList,
  searchByCustomerNameSensitive,
} from '@/api/domain/customers'
import {
  getShareList,
} from '@/api/domain/organize'
import {
  CONTINUOUS_MAP,
  CONTINUOUS_LIST,
  LEASE_PHASE_MAP,
  LEASE_PHASE_LIST,
  ONLINE_RIDE_STATUS_MAP,
  ONLINE_RIDE_STATUS_LIST,
  WORK_STATUS_MAP,
  WORK_STATUS_LIST,
  NO_WORK_REASON_MAP,
  NO_WORK_REASON_LIST,
  WORK_RATE_LIST,
  WORK_DURATION_LIST,
  TPH_LIST,
  SERVICE_SCORE_LIST,
} from './config'
import ExportListDialog from '@/bizComponents/ExportListDialog/index.vue'
import {
  getAllBrand,
  getSeriesListByBrand,
} from '@/api/carModel.js'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

/* 客户列表 */
async function getCustomerList(query, cb) {
  if (query.length >= 1) {
    const { code, data } = await searchByCustomerNameSensitive({
      customerType: 1,
      customerName: query,
      customerState: 1,
    })
    cb && cb(code === 1 && data ? data : [])
  }
}

export default {
  components: {
    ExportListDialog,
  },
  data() {
    return {
      exportLoading: false,
      configData: {
        formData: {
          list: [
            {
              el: 'select',
              itemConfig: {
                label: '客户名称',
                prop: 'customerId',
              },
              elConfig: {
                filterable: true,
                remote: true,
                'reserve-keyword': true,
                clearable: true,
                placeholder: '请输入',
                jsxRender: (option) => {
                  return <CustomerNameOptionItem data={option} />
                },
                'remote-method': (query) => {
                  getCustomerList(query, (list) => {
                    this.configData.formData.list[0].elConfig.options.list =
                      list
                  })
                },
                options: {
                  label: 'customerName',
                  value: 'id',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '是否续约',
                prop: 'continuous',
              },
              elConfig: {
                options: {
                  label: 'name',
                  value: 'value',
                  list: CONTINUOUS_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '租赁阶段',
                prop: 'leasePhase',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: LEASE_PHASE_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '品牌',
                prop: 'brandId',
              },
              elConfig: {
                events: {
                  change: this.handleBrandIdChange,
                  clear: this.handleBrandIdClear,
                },
                options: {
                  label: 'brandName',
                  value: 'brandId',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '车系',
                prop: 'seriesId',
                ref: 'seriesId',
              },
              elConfig: {
                disabled: true,
                options: {
                  label: 'seriesName',
                  value: 'seriesId',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '网约注册平台',
                prop: 'spId',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'id',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日网约状态',
                prop: 'yesterdayOnlineRideStatus',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: ONLINE_RIDE_STATUS_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日出车状态',
                prop: 'yesterdayWorkStatus',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: WORK_STATUS_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日不可出车原因',
                prop: 'noWorkReason',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: NO_WORK_REASON_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '本周出车率',
                prop: 'weekWorkRate',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: WORK_RATE_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '本月出车率',
                prop: 'monthWorkRate',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: WORK_RATE_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日出车时长',
                prop: 'yesterdayWorkDuration',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: WORK_DURATION_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '司机昨日TPH(单/小时)',
                prop: 'yesterdayTPH',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: TPH_LIST,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '昨日服务分',
                prop: 'yesterdayServiceScore',
              },
              elConfig: {
                placeholder: '请选择',
                options: {
                  label: 'name',
                  value: 'value',
                  list: SERVICE_SCORE_LIST,
                },
              },
            },
            {
              el: 'date-picker',
              itemConfig: {
                label: '租赁时间区间',
                prop: 'rentTime',
              },
            },
          ],
          customizeReset: this.customizeReset,
          dealWithSearch: this.dealWithSearch,
        },
        tableData: {
          columns: [
            {
              name: 'id',
              columnProps: {
                label: '序号',
                prop: 'id',
              },
              render: ({ $index }) => `${$index + 1}`,
            },
            {
              name: 'customerId',
              columnProps: {
                label: '客户ID',
                prop: 'customerId',
              },
            },
            {
              name: 'customerName',
              columnProps: {
                label: '客户名称',
                prop: 'customerName',
                width: 110,
              },
            },
            {
              name: 'continuous',
              columnProps: {
                label: '是否续约',
                prop: 'continuous',
              },
              render: ({ row }) => CONTINUOUS_MAP[row.continuous]?.name || '--',
            },
            {
              name: 'leasePhase',
              columnProps: {
                label: '租赁阶段',
                prop: 'leasePhase',
                width: 130,
              },
              render: ({ row }) =>
                LEASE_PHASE_MAP[row.leasePhase]?.name || '--',
            },
            {
              name: 'carId',
              columnProps: {
                label: '租赁车辆ID',
                prop: 'carId',
                width: 120,
              },
            },
            {
              name: 'plateNo',
              columnProps: {
                label: '租赁车牌号',
                prop: 'plateNo',
                width: 120,
              },
            },
            {
              name: 'carBrand',
              columnProps: {
                label: '品牌',
                prop: 'carBrand',
              },
            },
            {
              name: 'carSeries',
              columnProps: {
                label: '车系',
                prop: 'carSeries',
              },
            },
            {
              name: 'carModel',
              columnProps: {
                label: '车型',
                prop: 'carModel',
              },
            },
            {
              name: 'rentBeginTime',
              columnProps: {
                label: '租赁开始时间',
                prop: 'rentBeginTime',
                width: 170,
              },
            },
            {
              name: 'rentEndTime',
              columnProps: {
                label: '租赁结束时间',
                prop: 'rentEndTime',
                width: 170,
              },
            },
            {
              name: 'rentedDays',
              columnProps: {
                label: '累计已租天数',
                prop: 'rentedDays',
              },
            },
            {
              name: 'spName',
              columnProps: {
                label: '网约注册平台',
                prop: 'spName',
              },
            },
            {
              name: 'onlineRideStatus',
              columnProps: {
                label: '网约状态',
                prop: 'onlineRideStatus',
              },
              render: ({ row }) =>
                ONLINE_RIDE_STATUS_MAP[row.onlineRideStatus]?.name || '--',
            },
            {
              name: 'serviceScore',
              columnProps: {
                label: '昨日服务分',
                prop: 'serviceScore',
              },
            },
            {
              name: 'workStatus',
              columnProps: {
                label: '昨日出车状态',
                prop: 'workStatus',
              },
              render: ({ row }) =>
                WORK_STATUS_MAP[row.workStatus]?.name || '--',
            },
            {
              name: 'noWorkReason',
              columnProps: {
                label: '昨日不可出车原因',
                prop: 'noWorkReason',
              },
              render: ({ row }) =>
                NO_WORK_REASON_MAP[row.noWorkReason]?.name || '--',
            },
            {
              name: 'workStatusDuration',
              columnProps: {
                label: '昨日出车时长(小时)',
                prop: 'workStatusDuration',
              },
            },
            {
              name: 'peakWorkDurationProportion',
              columnProps: {
                label: '昨日高峰出车时长占比',
                prop: 'peakWorkDurationProportion',
              },
              render: ({ row }) => {
                if (row.peakWorkDurationProportion !== null) {
                  return `${(row.peakWorkDurationProportion * 100).toFixed(2)}%`
                }
                return '--'
              },
            },
            {
              name: 'serviceDurationProportion',
              columnProps: {
                label: '昨日服务时长占比',
                prop: 'serviceDurationProportion',
              },
              render: ({ row }) => {
                if (row.serviceDurationProportion !== null) {
                  return `${(row.serviceDurationProportion * 100).toFixed(2)}%`
                }
                return '--'
              },
            },
            {
              name: 'weekWorkRate',
              columnProps: {
                label: '本周出车率',
                prop: 'weekWorkRate',
              },
            },
            {
              name: 'monthWorkRate',
              columnProps: {
                label: '本月出车率',
                prop: 'monthWorkRate',
              },
            },
            {
              name: 'cancelRate',
              columnProps: {
                label: '昨日司机应答后取消率',
                prop: 'cancelRate',
              },
            },
            {
              name: 'yesterdayTPH',
              columnProps: {
                label: '司机昨日TPH(单/小时)',
                prop: 'yesterdayTPH',
              },
            },
            {
              name: 'weekTPH',
              columnProps: {
                label: '司机本周TPH(单/小时)',
                prop: 'weekTPH',
              },
            },
            {
              name: 'monthTPH',
              columnProps: {
                label: '司机本月TPH(单/小时)',
                prop: 'monthTPH',
              },
            },
            {
              name: 'yesterdayIncomeIPH',
              columnProps: {
                label: '司机收入昨日IPH(元/小时)',
                prop: 'yesterdayIncomeIPH',
              },
            },
            {
              name: 'weekIncomeIPH',
              columnProps: {
                label: '司机收入本周IPH(元/小时)',
                prop: 'weekIncomeIPH',
              },
            },
            {
              name: 'monthIncomeIPH',
              columnProps: {
                label: '司机收入本月IPH(元/小时)',
                prop: 'monthIncomeIPH',
              },
            },
          ],
          attrs: {
            'span-method': this.objectSpanMethod,
          },
          pagination: {
            pageSizes: [10, 20, 30, 50],
          },
          apiFn: getPersonOperateListSensitive,
        },
      },
      exportListDialogApi: {},
      listShow: false,
    }
  },
  methods: {
    // 合并单元格
    // 合并范围：前13列
    // 合并逻辑：如果当前行的customerId等于前一行的customerId则累计计数器，否则重置计数器
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (row && columnIndex <= 12) {
        const tableData = this.$refs.baseListManagement.$refs.baseTable.list
        if (
          rowIndex === 0 ||
          row.customerId !== tableData[rowIndex - 1].customerId
        ) {
          let rowspan = 0
          tableData.forEach((item) => {
            if (item.customerId === row.customerId) {
              rowspan++
            }
          })
          return [rowspan, 1]
        } else {
          return [0, 0]
        }
      }
      return [1, 1]
    },
    customizeReset() {
      this.$refs.baseListManagement.setItemData({
        elConfigKey: 'value',
        key: 'brandSeriesModel',
        data: {},
      })
    },
    dealWithSearch(params) {
      const _params = JSON.parse(JSON.stringify(params))
      const rentBeginTime = _params.rentTime ? _params.rentTime[0] : ''
      const rentEndTime = _params.rentTime ? _params.rentTime[1] : ''

      delete _params.rentTime

      delete _params.brandSeriesModel
      return {
        ..._params,
        rentBeginTime,
        rentEndTime,
      }
    },
    // 获取网约平台列表
    async getShareList() {
      const { code, data } = await getShareList()

      if (code === 1) {
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'list',
          key: 'spId',
          data: data || [],
        })
      }
    },
    getRouteQuery() {
      const {
        spId,
        deptId,
        yesterdayWorkStatus,
        noWorkReason,
        weekWorkRate,
        monthWorkRate,
        yesterdayWorkDuration,
        yesterdayTPH,
        yesterdayServiceScore,
      } = this.$route.query

      // 网约注册平台
      if (typeof spId !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'spId',
          Number(spId),
        )
      }
      // 所属部门
      if (typeof deptId !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'deptIdList',
          [Number(deptId)],
        )
      }
      // 昨日出车状态
      if (typeof yesterdayWorkStatus !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'yesterdayWorkStatus',
          Number(yesterdayWorkStatus),
        )
      }
      // 昨日不可出车原因
      if (typeof noWorkReason !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'noWorkReason',
          Number(noWorkReason),
        )
      }
      // 本周出车率
      if (typeof weekWorkRate !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'weekWorkRate',
          Number(weekWorkRate),
        )
      }
      // 本月出车率
      if (typeof monthWorkRate !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'monthWorkRate',
          Number(monthWorkRate),
        )
      }
      // 昨日出车时长
      if (typeof yesterdayWorkDuration !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'yesterdayWorkDuration',
          Number(yesterdayWorkDuration),
        )
      }
      // 司机昨日TPH
      if (typeof yesterdayTPH !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'yesterdayTPH',
          Number(yesterdayTPH),
        )
      }
      // 昨日服务分
      if (typeof yesterdayServiceScore !== 'undefined') {
        this.$set(
          this.configData.formData.formProps.model,
          'yesterdayServiceScore',
          Number(yesterdayServiceScore),
        )
      }
    },
    handleExportListDialogInit(exportListDialogApi) {
      this.exportListDialogApi = exportListDialogApi
    },
    // 导出数据
    async exportData() {
      if (this.exportLoading) return
      this.exportLoading = true
      try {
        const params =
          this?.$refs?.baseListManagement?.$refs?.searchForm?.getSearchParams() ||
          {}
        const { code } = await exportPersonOperateList(params)
        if (code !== 1) return
        this.$message.success(
          '所选数据已生成下载文件，请点击【导出列表】查看下载',
        )
      } finally {
        this.exportLoading = false
      }
    },
    // 导出列表
    exportList() {
      this.listShow = true
      const { getTableData } = this.exportListDialogApi
      getTableData && getTableData()
    },
    // 获取车辆品牌列表
    async getBrandList() {
      const { code, data } = await getAllBrand({ modelFilterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK })
      if (code === 1) {
        const temp = [{ brandName: '全部', brandId: '' }].concat(data || [])
        this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'brandId', data: temp })
      }
    },
    // 获取车辆车系列表
    async getSeriesList(val) {
      const { code, data } = await getSeriesListByBrand({
        brandId: val,
        modelFilterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
      })

      if (code === 1) {
        this.$refs.baseListManagement?.setItemData({ elConfigKey: 'disabled', key: 'seriesId', data: false })
        this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'seriesId', data: data || [] })
      }
    },
    handleBrandIdChange(val) {
      if (val) {
        this.$refs.baseListManagement?.getRefs({ type: 'form', formItemRef: 'seriesId' })?.resetField()
        this.getSeriesList(val)
      }
    },
    handleBrandIdClear() {
      this.$refs.baseListManagement?.getRefs({ type: 'form', formItemRef: 'seriesId' })?.resetField()
      this.resetFieldSeriesId()
    },
    resetFieldSeriesId() {
      this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'seriesId', data: [] })
      this.$refs.baseListManagement?.setItemData({ elConfigKey: 'disabled', key: 'seriesId', data: true })
    },
  },
  created() {
    this.getShareList()
    this.getBrandList()
  },
  mounted() {
    this.getRouteQuery()
  },
}
</script>
